import { theme } from './index';

export function createTransition(
  props = ['all'],
  {
    duration = theme.duration.fast,
    easing = theme.easing.sharp,
    delay = 0,
  } = {},
) {
  const formatMs = milliseconds => `${Math.round(milliseconds)}ms`;

  return (Array.isArray(props) ? props : [props])
    .map(
      animatedProp =>
        `${animatedProp} ${
          typeof duration === 'string' ? duration : formatMs(duration)
        } ${easing} ${typeof delay === 'string' ? delay : formatMs(delay)}`,
    )
    .join(',');
}
